import { z } from 'zod';
import { defaulted, translatableString } from '../common.js';
import { blockCommonSchema, listHeaderSchema, listSelectionSchema } from './base.js';
import { REQUEST_TYPES } from '../../constants/index.js';
/** 26 — Dron-shou paketlari */
export const droneshowPackagesBlock = blockCommonSchema.extend({
    type: z.literal('droneshow-packages'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        layout: z.enum(['cards', 'table']).default('cards'),
        highlightIndex: z.number().int().min(-1).max(10).default(1),
    }),
});
/** 27 — Dron-shou portfolio */
export const droneshowPortfolioBlock = blockCommonSchema.extend({
    type: z.literal('droneshow-portfolio'),
    data: listHeaderSchema.extend({
        selection: defaulted(listSelectionSchema),
        columns: z.union([z.literal(2), z.literal(3)]).default(3),
    }),
});
/**
 * 30 — Ariza formasi.
 *
 * `formType` qaysi turdagi ariza yaratilishini belgilaydi va forma qaysi
 * qo'shimcha maydonlarni ko'rsatishini aniqlaydi (TZ 5.1).
 */
export const requestFormBlock = blockCommonSchema.extend({
    type: z.literal('request-form'),
    data: z.object({
        title: translatableString({ max: 300 }),
        description: translatableString({ max: 1000 }),
        formType: z.enum(REQUEST_TYPES).default('general'),
        /** Mavzu tanlash ro'yxati (`general` uchun) */
        subjects: z
            .array(translatableString({ max: 200 }))
            .max(20)
            .default([]),
        showContactInfo: z.boolean().default(true),
        successMessage: translatableString({ max: 600 }),
    }),
});
/** 31 — Kontakt bloki */
export const contactInfoBlock = blockCommonSchema.extend({
    type: z.literal('contact-info'),
    data: z.object({
        title: translatableString({ max: 200 }),
        showPhones: z.boolean().default(true),
        showEmails: z.boolean().default(true),
        showAddress: z.boolean().default(true),
        showWorkHours: z.boolean().default(true),
        showSocials: z.boolean().default(true),
        showMap: z.boolean().default(false),
    }),
});
//# sourceMappingURL=special.js.map